<template>
  <div>
    <v-dialog v-model="isOpen" persistent width="632px">
      <v-card class="student-intro-dialog pb-8">
        <div class="student-intro-dialog__inner">
          <div class="student-intro-dialog__avatar">
            <div class="animoji mb-7">
              <img :src="viewer ? animojis[viewer.avatar] : animojis.owl" />
            </div>
          </div>

          <!-- eslint-disable-next-line max-len -->
          <h2 class="mb-5 text-center">{{ !viewerOnline ? $t('fillName') : $t('linkUnavailable') }}</h2>

          <v-text-field
            v-if="!viewerOnline"
            v-model="name"
            ref="StudentNameInput"
            :label="$t('name')"
            class="mb-4"
            outlined
            block
            @keyup.enter="submitForm"
          ></v-text-field>

          <v-btn
            v-if="!viewerOnline"
            :disabled="!name"
            :loading="isLoading"
            color="primary"
            large
            depressed
            rounded
            block
            @click="submitForm"
          >{{ $t('introEntry') }}</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { animojis } from '@/main.js';

export default {
  props: ['viewer'],
  data: () => ({
    isOpen: false,
    isLoading: false,
    name: '',
  }),
  created() {
    this.openDialog();
  },
  computed: {
    animojis() {
      return animojis;
    },
    viewerOnline() {
      return this.viewer.online;
    },
  },
  methods: {
    openDialog() {
      this.name = this.viewer.name;
      this.isOpen = true;
    },

    closeDialog() {
      this.isOpen = false;
    },

    submitForm() {
      if (this.name.length) {
        this.isLoading = true;
        this.$store
          .dispatch('viewerUpdate', {
            viewer: this.$route.params.viewer,
            value: this.name,
            action: 'name',
            lesson: this.$route.params.lesson,
          })
          .then(() => {
            this.isLoading = false;
            this.closeDialog();
            this.name = '';
            this.$emit('submit');
          });
      }
    },
  },
};
</script>

<style lang="scss">
.student-intro-dialog {
  &__avatar {
    margin: 0 auto;
    width: 214px;
  }
  &__inner {
    max-width: 270px;
    margin: 0 auto;

    padding-top: 8vh;
    padding-bottom: 8vh;
  }
}
</style>
